import { Box,Stack,Tabs } from "@mui/material";
import Tab from '@mui/material/Tab';
import * as React from 'react';
import { useContext,useState } from "react";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../context/UserContext";
import { trackEventMatomo } from '../../helpers/matomo';
import { TabPanelProps } from "../../types/helpers/types";
import ListaAnalises from "./ListaAnalises";
import ListaHistorico from "./ListaHistorico";
import PlanoNaoContratado from "./PlanoNaoContratado";
import PlanosDeAcaoComp from "./PlanosDeAcaoComp";

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ width: '100%' }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}


export default function PlanoDeAcaoTabs() {
  const { acessoPlanoDeAcao } = useContext(UserContext);
  const [value, setValue] = useState<number>(0);

  function handleChange(_event: React.SyntheticEvent, newValue: number) {
    const tabs = ['análise de execuções', 'planos de ação', 'inspeção de qualidade'];
    trackEventMatomo('plano de ação', 'click', 'aba', tabs[newValue]);
    setValue(newValue);
  };

  const { t } = useTranslation('translation');

  if (!acessoPlanoDeAcao) {
    return <PlanoNaoContratado />;
  }

  return (
    <>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor='secondary'
        textColor='secondary'
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label={t('ActionPlan.Tabs.analyzeFormExecutions')} value={0} />
        <Tab label={t('ActionPlan.Tabs.actionPlans')} value={1} />
        <Tab label={t('ActionPlan.Tabs.qualityInspection')} value={2} />
      </Tabs>
      <Stack direction='row' width='100%' spacing={5}>
        <CustomTabPanel value={value} index={0}>
          <ListaAnalises />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <PlanosDeAcaoComp />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <ListaHistorico />
        </CustomTabPanel>
      </Stack>
    </>
  );
}
